import React from 'react';

import { Box, Button, Container, Flex, Heading } from '@brand/components';

import { Link } from '@hoa/atoms';

import { useTranslation } from '@hoa/hooks';

export const HomePreFooter = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box as="section" pt={20} pb={32}>
      <Container>
        <Flex align="center" justify="center" direction="column">
          <Heading as="h3" variant="h4" textAlign="center" mb={10}>
            {t(`home:preFooter.title`)}
          </Heading>
          <Link href={`/categories`}
            anchorProps={{
              fontSize: `md`,
              _hover: {
                textDecoration: `none`,
              },
            }}>
            <Button size="md" variant="solid">
              {t(`home:hero:action`)}
            </Button>
          </Link>
        </Flex>
      </Container>
    </Box>
  );
};
